"use strict";
exports.__esModule = true;
exports.disableGlobalScroll = void 0;
var canUseDOM_1 = require("./canUseDOM");
/**
 * Add a class to body disable scroll
 *
 * @param {Boolean} disable
 */
var disableGlobalScroll = function (disable) {
    if (canUseDOM_1.canUseDOM()) {
        var root = window.document.documentElement; // <html> element
        if (root) {
            if (disable) {
                root.classList.add('noscroll');
            }
            else {
                root.classList.remove('noscroll');
            }
        }
    }
};
exports.disableGlobalScroll = disableGlobalScroll;
//# sourceMappingURL=disableGlobalScroll.js.map